function axlesFrom(placements) {
  var _a;
  const byAxle = /* @__PURE__ */ new Map();
  for (const placement of placements) {
    const group = (_a = byAxle.get(placement.ref.axle)) != null ? _a : [];
    group.push(placement);
    byAxle.set(placement.ref.axle, group);
  }
  return [...byAxle.entries()].sort((a, b) => a[0] - b[0]).map(([axle, wheels]) => {
    const first = wheels[0];
    if (!first) {
      return { axle, x: 0, y: 0, halfSpan: 0, section: 0 };
    }
    const zs = wheels.map((wheel) => Math.abs(wheel.position[2]));
    const halfSpan = Math.min(...zs);
    return {
      axle,
      x: first.position[0],
      y: first.radius,
      halfSpan,
      section: first.radius * 0.34
    };
  });
}
function railsFrom(beams) {
  if (beams.length === 0) return [];
  const xs = beams.map((beam) => beam.x);
  const minX = Math.min(...xs);
  const maxX = Math.max(...xs);
  const halfSpan = Math.min(...beams.map((beam) => beam.halfSpan));
  const y = beams[0].y;
  const section = beams[0].section;
  const z = halfSpan * 0.55;
  const length = maxX - minX;
  const x = (minX + maxX) / 2;
  return [
    { z: -z, y, x, length, section },
    { z, y, x, length, section }
  ];
}
export {
  axlesFrom,
  railsFrom
};
